import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geologias');

export const check = () => useBasicAuth.checkToken();

export const findGeologiaById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologia = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologiaByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllGeologiaByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const addGeologia = (obj) => 
  axios.post(urlAPI + "/addGeologia" , JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateGeologia = (obj) => 
  axios.put(urlAPI + "/updateGeologia/" + obj.geologia.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateCorGeologia = (obj) => 
  axios.put(urlAPI + "/updateCorGeologia/" + obj.geologia.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteGeologia = (id) => 
  axios.delete(urlAPI + "/deleteGeologia/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



//GEOLOGIA_CIDADE
export const findAllByGeologiaCidade_geologia = (geologia) => 
  axios.post(urlAPI + "/geologiacidade/geologia", JSON.stringify(geologia), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaCidade_cidade = (cidade) => 
  axios.post(urlAPI + "/geologiacidade/cidade", JSON.stringify(cidade), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaCidade = (geologia, cidade) => {
  let requestObj = {
    geologia: geologia,
    cidade: cidade
  }
  axios.post(urlAPI + "/geologiacidade", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}


//GEOLOGIA_ESTADO
export const findAllByGeologiaEstado_geologia = (geologia) => 
  axios.post(urlAPI + "/geologiaestado/geologia", JSON.stringify(geologia), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaEstado_estado = (estado) => 
  axios.post(urlAPI + "/geologiaestado/estado", JSON.stringify(estado), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaEstado = (geologia, estado) => {
  let requestObj = {
    geologia: geologia,
    estado: estado
  }
  axios.post(urlAPI + "/geologiaestado", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}


//GEOLOGIA_GRUPO
export const findAllByGeologiaGrupo_geologia = (geologia) => 
  axios.post(urlAPI + "/geologiagrupo/geologia", JSON.stringify(geologia), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaGrupo_grupo = (grupo) => 
  axios.post(urlAPI + "/geologiagrupo/grupo", JSON.stringify(grupo), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaGrupo = (geologia, grupo) => {
  let requestObj = {
    geologia: geologia,
    grupo: grupo
  }
  axios.post(urlAPI + "/geologiagrupo", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}



//GEOLOGIA_SUBSTANCIA
export const findAllByGeologiaSubstancia_geologia = (geologia) => 
  axios.post(urlAPI + "/geologiasubstancia/geologia", JSON.stringify(geologia), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaSubstancia_substancia = (substancia) => 
  axios.post(urlAPI + "/geologiasubstancia/substancia", JSON.stringify(substancia), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByGeologiaSubstancia = (geologia, substancia) => {
  let requestObj = {
    geologia: geologia,
    substancia: substancia
  }
  axios.post(urlAPI + "/geologiasubstancia", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}